import { Box } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-pro";
import { NumberFilterOperator, TextFilterOperator } from "components/shared/filters";
import { IChangedWorkItemResourceAssigne } from "models/work-items/IChangedWorkItemResourceAssignee";

const WorkItemReviewChangesColumns: GridColDef[] = [
    {
        field: 'workItemInstanceId',
        headerName: 'Work Item ID',
        width: 150,
        sortable: true,
        resizable: true,
        hideable: false,
        headerClassName: 'header',
        hideSortIcons: false,
        disableReorder: true,
        filterOperators: NumberFilterOperator
    },
    {
        field: 'workItemInstanceName',
        headerName: 'Work Item Name',
        flex: 1,
        minWidth: 200,
        sortable: true,
        resizable: true,
        hideable: false,
        headerClassName: 'header',
        hideSortIcons: false,
        disableReorder: true,
        filterOperators: TextFilterOperator
    },
    {
        field: 'responsibility',
        headerName: 'Responsibility',
        width: 150,
        sortable: false,
        resizable: true,
        hideable: true,
        headerClassName: 'header',
        hideSortIcons: false,
        filterOperators: TextFilterOperator
    },
    {
        field: 'currentPrimaryResource',
        headerName: 'Current Primary Resource',
        cellClassName: "grid-cell-display-block",
        width: 200,
        sortable: false,
        resizable: true,
        hideable: true,
        headerClassName: 'header',
        hideSortIcons: false
    },
    {
        field: '',
        headerName: 'Pending Resource(s)',
        cellClassName: (params: GridCellParams<any, number>) => {
            if (params?.row?.newAlternateResources?.length) {
                return "grid-cell-display-block";
            }
            return '';
        },
        width: 200,
        sortable: false,
        resizable: true,
        hideable: true,
        headerClassName: 'header',
        hideSortIcons: false,
        renderCell: (params) => {
            return (
                <>
                    {!!(params.row as IChangedWorkItemResourceAssigne).newAlternateResources?.length &&
                        <>
                            {(params.row as IChangedWorkItemResourceAssigne).newAlternateResources.map(userName => {
                                return (<Box key={userName}>{userName}</Box>)
                            })}
                        </>
                    }
                </>
            );
        }
    },
    {
        field: 'isAssignOnInProgress',
        headerName: 'In progress Task Reassignment',
        width: 200,
        sortable: false,
        resizable: true,
        hideable: true,
        headerClassName: 'header',
        hideSortIcons: false,
        renderCell: (param) => {
            return param.value === true ? 'Yes' : 'No';
        }
    }
];

export default WorkItemReviewChangesColumns;